import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { UpdateParticipantEmbeddableForm } from '../mutations/updateParticipantEmbeddableForm.mutation';
import type {
  UpdateParticipantEmbeddableFormMutation,
  UpdateParticipantEmbeddableFormMutationVariables,
} from '../types';

export const useUpdateParticipantEmbeddableFormMutation = (
  options?: MutationOptions<
    UpdateParticipantEmbeddableFormMutation,
    UpdateParticipantEmbeddableFormMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateParticipantEmbeddableForm), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
